import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import Lottie from 'react-lottie-player';
import Tree from '../../../../assets/tree/tree.svg';
import SpiralImg from '../../../../assets/tree/spiral.png';
import TreeHouseLetsgoIcon from '../../../../assets/tree/treehouse-letsgo-with-stars.png';
import Door from '../../../../assets/tree/door.svg';
import DoorOpen from '../../../../assets/tree/door-open.svg';
import RoundWindow from '../../../../assets/tree/round-window.svg';
import RoundWindow1 from '../../../../assets/images/round-window-1st.svg';
import RoundWindow2 from '../../../../assets/images/round-window-2nd.svg';
import MapBg from '../../../../assets/images/map-bg.svg';
import SpaceThemeImg from '../../../../assets/images/sky-bg.png';
import './kids-room-taletree.css';
import { useAuth } from '../../../auth/Auth';
import TreeInterestBranches from './TreeInterestBranches';
import { getKidsCompanionImg } from '../../../../utils/companion.utils';
import TreeCreations from './TreeCreations';
import TreeSideButtons from './TreeSideButtons';
import { TREEHOUSE_ROUTE } from '../../../../constants/routes.constants';
import loaderJson from '../../../../assets/json/Loader.json';
import DoorStarsImg from '../../../../assets/tree/Door_Star.png';
import TreeShareButton from './TreeShareButton';

const KidsRoomTaleTree = ({
  branchesList,
  isMyRoom = false,
  creator = {},
  acceptedChallenges = [],
  showAddButtons = false,
  isTreePage = false,
  kidsData = {},
  setShowAnimation,
  updatedBranches = [],
}) => {
  const { dependent, guardian, school, partner } = useAuth();
  const history = useHistory();
  const [playLoader, setPlayLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  const onTaletreeTreehouseClick = () => {
    if (window.location.hostname === 'taletree.com') {
      history.push(`${TREEHOUSE_ROUTE}/taletree`);
    }
  };

  const setImageLoadedFun = () => {
    setTimeout(() => {
      setShowLoader(false);
      setPlayLoader(false);
      if (setShowAnimation) {
        setShowAnimation(true);
      }
    }, 2000);
  };

  return (
    <Box
      sx={{
        height: 'auto',
        width: '100%',
        background: '#141739',
        overflow: 'auto',
      }}
    >
      <div
        className="map-loader"
        style={{
          position: isTreePage ? 'fixed' : 'unset',
          display: showLoader ? '' : 'none',
          backgroundImage: `url(${SpaceThemeImg})`,
          backgroundColor: 'unset',
          zIndex: 9999,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <Lottie
          loop={true}
          play={playLoader}
          animationData={loaderJson}
          className="map-loader-in"
        />
      </div>
      <Box
        sx={{ backgroundImage: MapBg }}
        className="kids-room-taletree home_login_tree"
      >
        <Box
          component="img"
          className="tree-img"
          src={Tree}
          onLoad={setImageLoadedFun}
        />
        <Box
          className="treehouse-img-wrapper"
          onClick={onTaletreeTreehouseClick}
        >
          <Box
            component="img"
            className="letsgo-img"
            src={TreeHouseLetsgoIcon}
          />
          <Box
            sx={{
              backgroundColor: '#2196F3',
              color: 'white',
              borderRadius: '16px',
              padding: '15px 16px',
              display: 'inline-block',
              position: 'absolute',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              top: '-19%',
              left: '109%',
              width: '158px',
              zIndex: 999,
              ':after': {
                content: '""', // Arrow
                position: 'absolute',
                top: '35%',
                left: '-7px',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '8px 8px 8px 0',
                borderColor: 'transparent #2196F3 transparent transparent',
              },
            }}
            className="treehouse-text-box"
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, fontSize: '12px' }}
            >
              Discover the TaleTree Treehouse now!!
            </Typography>
          </Box>
        </Box>
        {/* Door positioned absolutely over the background */}
        <Box className="door">
          <Box
            component="img"
            src={Door}
            alt="Door-Close"
            className="door-close"
          />
          <Box
            component="img"
            src={DoorOpen}
            alt="Door-Open"
            className="door-open img"
          />
          <Box
            component="img"
            src={getKidsCompanionImg(
              !isMyRoom
                ? dependent
                  ? kidsData?.profile?.taletree_friend
                  : creator?.username
                  ? creator?.profile?.taletree_friend
                  : 'guest'
                : dependent?.profile?.taletree_friend
            )}
            alt="companion"
            sx={{
              position: 'absolute',
              top: '80%',
              left: '47.5%',
              width: '5%',
              height: '11%',
            }}
            className="door-open"
          />
          {!isMyRoom && !dependent && !creator.username && (
            <Box
              component="img"
              className="door-stars door-open"
              src={DoorStarsImg}
            />
          )}
          <Box
            sx={{
              backgroundColor: '#2196F3',
              color: 'white',
              borderRadius: '16px',
              padding: '15px 16px',
              display: 'inline-block',
              position: 'absolute',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              top: '81%',
              left: '54%',
              width: '15%',
              ':after': {
                content: '""', // Arrow
                position: 'absolute',
                top: '35%',
                left: '-7px',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '8px 8px 8px 0',
                borderColor: 'transparent #2196F3 transparent transparent',
              },
            }}
            className="door-open"
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, fontSize: '14px' }}
            >
              {isMyRoom
                ? `${dependent.username}, welcome to your TaleTree!! Enjoy :)`
                : dependent
                ? `Welcome ${dependent?.username} to ${kidsData?.username}'s TaleTree.`
                : creator?.username
                ? `Welcome to ${creator?.username}'s TaleTree.`
                : 'This could be your TaleTree, join us now!!'}
            </Typography>
          </Box>
        </Box>
        {/* Hangline positioned absolutely over the background */}
        <TreeCreations
          // kidId={isMyRoom ? dependent?.id : creator?.id}
          kidId={kidsData?.id}
          acceptedChallenges={acceptedChallenges}
        />
        <Box className="Win_box1">
          <Box
            component="img"
            src={RoundWindow}
            alt="window"
            className="Win_img1"
          />
          <Box
            component="img"
            src={RoundWindow1}
            alt="window"
            className="Win_img_hvr1"
          />
          <Box
            sx={{
              backgroundColor: '#2196F3',
              color: 'white',
              borderRadius: '16px',
              padding: '15px 16px',
              position: 'absolute',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              top: '55%',
              left: '57%',
              width: '185px',
              zIndex: 9,
              ':after': {
                content: '""', // Arrow
                position: 'absolute',
                top: '35%',
                left: '-7px',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '8px 8px 8px 0',
                borderColor: 'transparent #2196F3 transparent transparent',
              },
            }}
            className="win1-text-box"
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, fontSize: '12px' }}
            >
              {!dependent && !guardian && !school && !partner
                ? 'You could add Branches to your TaleTree here. Climb aboard today.'
                : 'You can navigate between all your Branches here.'}
            </Typography>
          </Box>
        </Box>
        <Box className="Win_box2">
          <Box
            component="img"
            src={RoundWindow}
            alt="window"
            className="Win_img2"
          />
          <Box
            component="img"
            src={RoundWindow2}
            alt="window"
            className="Win_img_hvr2"
          />
          <Box
            sx={{
              backgroundColor: '#2196F3',
              color: 'white',
              borderRadius: '16px',
              padding: '15px 16px',
              position: 'absolute',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              top: '66%',
              left: '52%',
              width: '193px',
              zIndex: 9,
              ':after': {
                content: '""', // Arrow
                position: 'absolute',
                top: '35%',
                left: '-7px',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderStyle: 'solid',
                borderWidth: '8px 8px 8px 0',
                borderColor: 'transparent #2196F3 transparent transparent',
              },
            }}
            className="win2-text-box"
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, fontSize: '12px' }}
            >
              Discover the best creations and Treehouses.
            </Typography>
          </Box>
        </Box>
        <TreeInterestBranches
          branchesList={branchesList}
          updatedBranches={updatedBranches}
        />
        <Box component="img" className="spiral-img" src={SpiralImg} />
        {showAddButtons && <TreeSideButtons dependent={dependent} />}
        {showAddButtons && <TreeShareButton dependent={dependent} />}
      </Box>
    </Box>
  );
};

export default KidsRoomTaleTree;
